import { render, staticRenderFns } from "./primaryPage.vue?vue&type=template&id=70bde01a&scoped=true&"
import script from "./primaryPage.vue?vue&type=script&lang=ts&"
export * from "./primaryPage.vue?vue&type=script&lang=ts&"
import style0 from "./primaryPage.vue?vue&type=style&index=0&id=70bde01a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bde01a",
  null
  
)

export default component.exports